import { render, staticRenderFns } from "./DuelsGameUsers.vue?vue&type=template&id=4ceed5af&scoped=true"
import script from "./DuelsGameUsers.vue?vue&type=script&lang=js"
export * from "./DuelsGameUsers.vue?vue&type=script&lang=js"
import style0 from "./DuelsGameUsers.vue?vue&type=style&index=0&id=4ceed5af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceed5af",
  null
  
)

export default component.exports